module.exports = __webpack_public_path__ + "media/ekszerteknos_k.4e0d6b38.mp3";